module.exports = __webpack_public_path__ + "static/img/Design2022.366b8b5b.png";